<script setup lang="ts">
  import { useSlots } from "vue";
  import { Text } from "@ui-kit";

  const { title, subtitle } = defineProps<{ title: string; subtitle?: string }>();
  const emit = defineEmits<{
    "click:left": [value: void];
    "click:right": [value: void];
  }>();

  const slots = useSlots();
</script>

<template>
  <div class="top-bar">
    <div class="top-bar__left" @click="emit('click:left')" data-testid="top-bar-left-action">
      <slot v-if="slots.left" name="left" />
      <span v-else class="top-bar__placeholder" />
    </div>
    <div class="top-bar__title-container">
      <Text class="top-bar__title" font="body-medium-16" :wrap="false" data-testid="top-bar-title">{{ title }}</Text>
      <Text
        v-if="subtitle"
        class="top-bar__subtitle"
        font="body-regular-12"
        :wrap="false"
        data-testid="top-bar-subtitle"
      >
        {{ subtitle }}
      </Text>
    </div>
    <div class="top-bar__right" @click="emit('click:right')" data-testid="top-bar-right-action">
      <slot v-if="slots.right" name="right" />
      <span v-else class="top-bar__placeholder" />
    </div>
  </div>
</template>

<style scoped>
  .top-bar {
    display: flex;
    align-items: center;
    padding: 0 8px;
    justify-content: space-between;
  }

  .top-bar__right,
  .top-bar__left {
    display: flex;
    padding: 12px;
  }

  .top-bar__placeholder {
    width: 24px;
    height: 24px;
  }

  .top-bar__title-container {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex: 1;
    text-align: center;
  }

  .top-bar__title-container :deep(.text) {
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>
